import { Component, OnInit, Inject } from '@angular/core';
import { QuoteService } from '../../quote-service.service';
import { InterpretationService } from '../../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../../../app/app.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-attach-temperature-inspection-popup',
  templateUrl: './attach-temperature-inspection-popup.component.html',
  styleUrls: ['./attach-temperature-inspection-popup.component.scss']
})
export class AttachTemperatureInspectionPopupComponent implements OnInit {

  constructor(private _quotes: QuoteService,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _dialogRef: MatDialogRef<AttachTemperatureInspectionPopupComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _app: AppService,
  private _dialog: MatDialog) { }

  ngOnInit() {

  }

  onNoClick(){
    this._dialogRef.close(false);
  }
  onYesClick(){
    this._dialogRef.close(true);
  }

}
